import { useOTPs, useSubscriptions } from '../collections/hooks';
import { useInfluencerId } from '@client/new/contexts/InfluencerIdContext';
import { OTP, Subscription } from '../collections/collections.domain';
import { SelectField } from '@client/new/components/SelectField/SelectField';

type SelectProps<T extends { id: number }> = {
  value: T['id'] | undefined;
  onChange: (value: T | undefined) => void;
  label?: string;
  error?: string;
  placeholder?: string;
};

export const OTPSelect = (p: SelectProps<OTP>) => {
  const otps = useOTPs(useInfluencerId());
  return (
    <SelectField
      label={p.label}
      value={p.value}
      options={otps.type === 'fetched' ? otps.value : []}
      getLabel={(o) => o.name ?? ''}
      onChange={p.onChange}
      error={p.error}
      placeholder={p.placeholder}
    />
  );
};

export const SubscriptionSelect = (p: SelectProps<Subscription>) => {
  const subs = useSubscriptions(useInfluencerId());

  return (
    <SelectField
      label={p.label}
      value={p.value}
      options={subs.type === 'fetched' ? subs.value : []}
      getLabel={(o) => o.name ?? ''}
      onChange={p.onChange}
      error={p.error}
    />
  );
};

const subscriptionOption = {
  id: -1,
  type: 'subscription',
  name: 'Subscription',
} as const;

export const ProgramSelect = (
  p: SelectProps<OTP | typeof subscriptionOption>,
) => {
  const otps = useOTPs(useInfluencerId());

  return (
    <SelectField
      label={p.label}
      value={p.value}
      options={
        otps.type === 'fetched' ? [subscriptionOption, ...otps.value] : []
      }
      getLabel={(o) =>
        o.type === 'subscription' ? o.name : `OTP: ${o.name ?? ''}`
      }
      onChange={p.onChange}
      error={p.error}
    />
  );
};
